/* Sweet World — Theme JS */
(function() {
  'use strict';

  // Mobile menu toggle
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');
  if (menuToggle && menu) {
    menuToggle.addEventListener('click', () => menu.classList.toggle('is-open'));
  }

  // Quantity picker
  document.querySelectorAll('[data-qty]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-picker').querySelector('input');
      const step = parseInt(btn.dataset.qty, 10);
      const val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
      input.value = val;
    });
  });

  // Product sliders
  document.querySelectorAll('[data-slider]').forEach(slider => {
    const track = slider.querySelector('[data-track]');
    const prev = slider.querySelector('[data-slider-prev]');
    const next = slider.querySelector('[data-slider-next]');
    if (!track || !prev || !next) return;
    const scrollBy = () => Math.round(track.clientWidth * 0.8);
    prev.addEventListener('click', () => track.scrollBy({ left: -scrollBy(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left:  scrollBy(), behavior: 'smooth' }));
  });

  // Cart drawer
  const drawer = document.getElementById('cart-drawer');
  const openBtn = document.querySelector('[data-cart-open]');
  const closeBtns = document.querySelectorAll('[data-cart-close]');
  const drawerBody = drawer && drawer.querySelector('[data-cart-body]');

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    fetchCart();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
  }
  if (openBtn) {
    openBtn.addEventListener('click', e => {
      e.preventDefault();
      openDrawer();
    });
  }
  closeBtns.forEach(b => b.addEventListener('click', closeDrawer));

  async function fetchCart() {
    if (!drawerBody) return;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCart(cart);
      updateCartCount(cart.item_count);
    } catch (err) { console.error(err); }
  }

  function renderCart(cart) {
    if (!drawerBody) return;
    if (!cart.items || cart.items.length === 0) {
      drawerBody.innerHTML = '<p class="cart-drawer__empty">Noch leer — füll mich mit Süßem! 🍭</p>';
      return;
    }
    const lines = cart.items.map(item => `
      <div style="display:flex;gap:.75rem;padding:.75rem 0;border-bottom:1px solid #f2f2f2;">
        <img src="${item.image}" alt="${item.product_title}" style="width:64px;height:64px;object-fit:cover;border-radius:12px;">
        <div style="flex:1;">
          <div style="font-weight:700;">${item.product_title}</div>
          <div style="font-size:.85rem;opacity:.6;">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          <div style="display:flex;justify-content:space-between;align-items:center;margin-top:.3rem;">
            <span>${item.quantity} × ${formatMoney(item.final_price)}</span>
            <button data-remove="${item.key}" style="background:transparent;border:0;cursor:pointer;color:#888;text-decoration:underline;font-size:.8rem;">Entfernen</button>
          </div>
        </div>
      </div>
    `).join('');

    drawerBody.innerHTML = `
      <div style="flex:1;overflow:auto;">${lines}</div>
      <div style="padding-top:1rem;border-top:2px solid #f2f2f2;margin-top:1rem;">
        <div style="display:flex;justify-content:space-between;font-weight:700;font-size:1.2rem;">
          <span>Zwischensumme</span><span>${formatMoney(cart.total_price)}</span>
        </div>
        <a href="/checkout" class="btn btn--primary btn--xl" style="width:100%;margin-top:.75rem;">Zur Kasse 👉</a>
      </div>`;

    drawerBody.querySelectorAll('[data-remove]').forEach(b => {
      b.addEventListener('click', () => removeItem(b.dataset.remove));
    });
  }

  async function removeItem(key) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    fetchCart();
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  // Quick-add on product cards
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.product-card__quick-add');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.productId;
    if (!id) return;
    btn.textContent = '✓';
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity: 1 })
      });
      openDrawer();
    } catch (err) { console.error(err); }
    setTimeout(() => { btn.textContent = '+'; }, 1200);
  });

  // Init cart count
  fetchCart();
})();
